import client from "@/services/api.client";
import { ApiResponse } from "@/models/api.models";
import { Note } from "@/features/notes/api/notes.models";

export const notesServices = {
  async getNotes() {
    return client
      .post<ApiResponse<Note[]>>("/GetNotes.php", {})
      .then((resp) => resp.data.response);
  },

  async addNote(payload: { message: string; poolID: number }) {
    return client.post<unknown>("/AddNote.php", payload);
  },

  async updateNote(payload: { message: string; noteID: number }) {
    return client.post<unknown>("/UpdateNote.php", payload);
  },

  async deleteNote(payload: { msgID: number }) {
    return client.post<unknown>("/DeleteNote.php", payload);
  },
};
